import axios from 'axios';
import * as settings from 'settings/settings';

export function getTimeZone(latitude, longitude, timestamp, languageCode) {

    /*
        attenzione! se google risponde con un
        Response to preflight request doesn't pass access control check: The value of the 'Access-Control-Allow-Origin' header in the response must not be the wildcard '*' when the request's credentials mode is 'include'. Origin 'http://localhost' is therefore not allowed access. The credentials mode of requests initiated by the XMLHttpRequest is controlled by the withCredentials attribute.
        allora bisogna fare attenzione al servizio authenticationInterceptor, molto probabilmente sta settando delle proprietà CORS che non sono necessarie

        ATTENZIONE!
        bisogna utilizzare una google API BROWSER key o non funziona
    */

    var url = "https://maps.googleapis.com/maps/api/timezone/json?location=" + latitude + "," + longitude
        + "&timestamp=" + timestamp + "&language=" + languageCode
        + "&key=" + settings.googleTimeZoneAPIKey;

    return axios.get(url);
}


// WEBPACK FOOTER //
// ./src/services/apis/google/googleServices.js